'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fr_FR = require('../../date-picker/locale/fr_FR');

var _fr_FR2 = _interopRequireDefault(_fr_FR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _fr_FR2['default'];